import React$1, { PureComponent } from 'react';
import { classNames } from '../../../../utilities/css.js';
import styles from '../../Connected.scss.js';

class Item extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      focused: false
    };

    this.handleBlur = () => {
      this.setState({
        focused: false
      });
    };

    this.handleFocus = () => {
      this.setState({
        focused: true
      });
    };
  }

  render() {
    var {
      focused
    } = this.state;
    var {
      children,
      position
    } = this.props;
    var className = classNames(styles.Item, focused && styles['Item-focused'], position === 'primary' ? styles['Item-primary'] : styles['Item-connection']);
    return /*#__PURE__*/React$1.createElement("div", {
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      className: className
    }, children);
  }

}

export { Item };
